import { CHANGE_CURRENCY } from '../constants';

const initialState = {
    currency: 'Euro/€',
};

export const currency = (state = initialState, action) => {
    switch(action.type) {
        case CHANGE_CURRENCY:
            return {
                ...state,
                currency: action.currency
            }
        default:
            return state
    }
}
